const ASSET_ITEM_LABELS = {
    ASSET_TYPE: "Asset Type",
    LATITUDE: "Latitude",
    LONGITUDE: "Longitude"
};

export default ASSET_ITEM_LABELS;